import { Pokemon, Tier } from "../types/pokemon";
import { getBuildForPokemon } from "../data/smogonSets";

export function formatPokemonForShowdown(pokemon: Pokemon, tier: Tier): string {
  const build = getBuildForPokemon(pokemon, tier);
  const lines: string[] = [];

  // Name @ Item
  const name = pokemon.name.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join("-");
  const itemPart = build.item ? ` @ ${build.item}` : "";
  lines.push(`${name}${itemPart}`);

  // Ability
  if (build.ability) lines.push(`Ability: ${build.ability}`);

  // EVs
  const evParts: string[] = [];
  const evLabels: Record<string, string> = {
    hp: "HP", atk: "Atk", def: "Def", spa: "SpA", spd: "SpD", spe: "Spe",
  };
  for (const [key, val] of Object.entries(build.evs)) {
    if (val && val > 0) evParts.push(`${val} ${evLabels[key] || key}`);
  }
  if (evParts.length) lines.push(`EVs: ${evParts.join(" / ")}`);

  // Nature
  if (build.nature && build.nature !== "Serious") {
    lines.push(`${build.nature} Nature`);
  }

  // Moves
  for (const move of build.moves) {
    if (move) lines.push(`- ${move}`);
  }

  return lines.join("\n");
}

export function formatTeamForShowdown(team: Pokemon[], tier: Tier): string {
  return team.map(p => formatPokemonForShowdown(p, tier)).join("\n\n");
}

export function formatBothTeams(team1: Pokemon[], team2: Pokemon[], tier: Tier): string {
  const t1 = formatTeamForShowdown(team1, tier);
  const t2 = formatTeamForShowdown(team2, tier);
  return `=== Joueur 1 ===\n\n${t1}\n\n=== Joueur 2 ===\n\n${t2}`;
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  }
}

export function openShowdown(): void {
  window.open("https://play.pokemonshowdown.com/teambuilder", "_blank");
}
